export default function clamp(val, lo, hi) {
	if (val < lo) return lo;
	else if (val > hi) return hi;
	else return val;
}
